module.exports = __webpack_public_path__ + "img/vod-01.19d14fe9.jpg";